import { IHisInformationApplicable, instanceOfIHisInformationApplicable } from "../../document/items";
import { HisInformationItem, HisInformation } from "..";
import { IHisItemAction } from ".";
import { IDocumentEditable } from "../../../components/document/editor";
import { ReloadDetailKinds, ReloadKinds } from "../behavior";
import { LoggerFactory } from "../../../utilities/logger";

export class HisItemUpdateAction implements IHisItemAction {
  applicableItems: IHisInformationApplicable[][];
  informationItems: HisInformationItem[];
  managerIds: string[];
  hospitalizationItems: HisInformationItem[];
  diseaseItems: HisInformationItem[];
  
  constructor(document: IDocumentEditable, info: HisInformation, isAutoUpdate: boolean, shouldUpdateEmptyObjectOnly: boolean) {
    if (shouldUpdateEmptyObjectOnly) {
      this._logger.debug("空のオブジェクトのみ更新対象とします。");
    }
    this.applicableItems = this.getApplicableItems(document, isAutoUpdate, shouldUpdateEmptyObjectOnly);
    this.informationItems = info.items.concat();
    this.managerIds = info.managerIds;

    // wfmst.WorkflowSettingsのHisInfoでWF→通常のHIS項目に値を反映させる機能を有効にした場合、ここに複数の項目が順番通りに格納されてくる
    this.hospitalizationItems = info.hospitalizationItems;
    this.diseaseItems = info.diseaseItems;
  }

  private getApplicableItems(document: IDocumentEditable, isAutoUpdate: boolean, shouldUpdateEmptyObjectOnly: boolean): IHisInformationApplicable[][] {
    const items = document.itemSets.map(itemSet => itemSet.items
      .filter(instanceOfIHisInformationApplicable)
      .filter(item => item.hisItemParameter != null)
      .filter(item => this.shouldAppliedUpdate(item, isAutoUpdate, shouldUpdateEmptyObjectOnly))
    );
    return items;
  }
  
  private shouldAppliedUpdate(item: IHisInformationApplicable, isAutoUpdate: boolean, shouldUpdateEmptyObjectOnly: boolean): boolean {
    if (shouldUpdateEmptyObjectOnly && !item.isEmpty) {
      // 空ではないオブジェクトは対象外
      return false;
    }
    // ReloadKind.ManualAutoは依頼の証明期間を文書内の入院日に反映させる項目に対して指定されている
    // V1では更新ボタンで更新させているようなので同様の挙動にしている(編集開始時のHIS項目の自動更新では更新しない)
    if (item.hisItemParameter.reloadKind === ReloadKinds.Auto || (!isAutoUpdate && item.hisItemParameter.reloadKind === ReloadKinds.ManualAuto)) {
      return this.shouldAppliedAutoUpdate(item);
    }
    // ReloadKind.Manual:任意設定はオブジェクトの値ではなく選択画面のリストの更新のことらしいのでここでは設定しない
    return false;
  }

  /**
   * 愛大でフリー入力状態のHIS項目（患者住所など）を毎回更新の対象にしたくないとの要望あり、
   * mst.HisInformationSettingsにカラム追加して挙動を変更可能にしている
   */
  private shouldAppliedAutoUpdate(item: IHisInformationApplicable): boolean {
    if (item.hisItemParameter.reloadDetailKind === ReloadDetailKinds.Everytime) { return true; }
    if (item.hisItemParameter.reloadDetailKind === ReloadDetailKinds.ExceptFreeInput) {
      return !item.shouldInputFree;
    }
    this._logger.warn("自動更新の詳細種別に不明な値が指定されています。ReloadDetailKind: " + item.hisItemParameter.reloadDetailKind);
    return true;
  }

  private readonly _logger = LoggerFactory.getLogger();
}
